<template>
  <b-tab :title="title" :title-link-class="classTab" :active="active">
    <b-card-text>
      <slot></slot>
    </b-card-text>
  </b-tab>
</template>

<script>


export default {
  name: 'SGPTabComponent',

  props: {
    title: {
      type: String,
      required: true,
      default: "Título"
    },
    active: {
      type: Boolean,
      required: false,
      default: false
    },
    classTab: {
      type: String,
      required: false,
      default: ""
    }
    
  }
}
</script>